'use strict';

var $ = require('jquery');
var offcanvasdialog = require('../components/offcanvasdialog');
var countries = require('../components/country-selection/countries');
var uniform = require('../components/uniform');

exports.init = function () {
    $('.ocd-overlay').remove();
    $('#wrapper').append($('<div class="ocd-overlay"></div>'));
    offcanvasdialog.init(
        'footer-country-switcher-trigger',
        {
            position: document.documentElement.lang === 'ar' ? 'left' : 'right',
            overlay: true,
            closeOnClick: true,
            closeOnX: true,
            additionalClass: 'footer-country-switcher-fly-in',
            headerStyle: 'over'
        },
        function ($triggerButton, $flyinContainer) {
            countries.init($flyinContainer.find('.country-select'));
            $('input[name=queryString]').val(window.location.search);
            uniform();
        }
    );

    countries.init($('.footer-section-country-switch .country-select'));
};
